import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { QuestionCircleOutlined, CloseOutlined, ExpandOutlined, RobotOutlined } from '@ant-design/icons';
import { Modal, Tooltip } from 'antd';
import { helpConfigsApi } from '../services/api-services';
import './HelpSidebar.css';

const openQuickChat = () => {
  if ((window as any).__TAURI__) {
    import('@tauri-apps/api/webviewWindow').then(async ({ WebviewWindow }) => {
      const win = await WebviewWindow.getByLabel('quick-chat');
      if (win) { win.setFocus(); } else {
        new WebviewWindow('quick-chat', { url: 'index.html?__route=%2Fquick-chat', title: '快速聊天', width: 800, height: 700 });
      }
    });
  } else {
    const w = 800, h = 700;
    const left = (window.screen.width - w) / 2;
    const top = (window.screen.height - h) / 2;
    if ((window as any).__quickChatWin && !(window as any).__quickChatWin.closed) {
      (window as any).__quickChatWin.focus();
    } else {
      (window as any).__quickChatWin = window.open('/quick-chat', 'quickChat', `width=${w},height=${h},left=${left},top=${top}`);
    }
  }
};

const HelpSidebar: React.FC = () => {
  const [configs, setConfigs] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [maximized, setMaximized] = useState(false);
  const [hidden, setHidden] = useState(false);
  const location = useLocation();

  useEffect(() => {
    helpConfigsApi.list().then((res: any) => setConfigs(res)).catch(() => {});
  }, []);

  const matched = useMemo(() => {
    for (const cfg of configs) {
      try {
        if (new RegExp(cfg.url_pattern).test(location.pathname))
          return { link: cfg.link, embeddable: cfg.embeddable !== false };
      } catch {}
    }
    return null;
  }, [configs, location.pathname]);

  const handleClose = () => { setOpen(false); setMaximized(false); };

  return (
    <>
      {!hidden && <div className="right-fab-group">
        <Tooltip title="关闭" placement="left">
          <div className="right-fab-btn" onClick={() => setHidden(true)}>
            <CloseOutlined style={{ fontSize: 13 }} />
          </div>
        </Tooltip>
        <Tooltip title="快速聊天" placement="left">
          <div className="right-fab-btn" onClick={openQuickChat}>
            <RobotOutlined style={{ fontSize: 16 }} />
          </div>
        </Tooltip>
        {matched && (
          <Tooltip title="帮助" placement="left">
            <div
              className={`right-fab-btn${open ? ' right-fab-btn--active' : ''}`}
              onClick={() => setOpen(v => !v)}
            >
              <QuestionCircleOutlined style={{ fontSize: 16 }} />
            </div>
          </Tooltip>
        )}
      </div>}

      {open && !maximized && matched && (
        <div className="help-sidebar-panel">
          <div className="help-sidebar-panel-header">
            <span>帮助与咨询</span>
            <span className="help-sidebar-panel-actions">
              <ExpandOutlined className="help-sidebar-panel-action" onClick={() => setMaximized(true)} title="最大化" />
              <CloseOutlined className="help-sidebar-panel-action" onClick={handleClose} title="关闭" />
            </span>
          </div>
          <iframe src={matched.link} className="help-sidebar-iframe" title="帮助页面" />
        </div>
      )}

      <Modal
        open={maximized}
        onCancel={handleClose}
        footer={null}
        width="90vw"
        style={{ top: 20, maxWidth: 1200 }}
        styles={{ body: { height: '85vh', padding: 0 } }}
        title="帮助与咨询"
        destroyOnHidden
      >
        <iframe src={matched?.link} style={{ width: '100%', height: '100%', border: 'none' }} title="帮助页面" />
      </Modal>
    </>
  );
};

export default HelpSidebar;
